import type { CreateShopReturnReasonDto, ShopDto } from "../generated/schema";
import { useApiMutation } from "./use-api-mutation";
import useInvalidateShop from "./use-invalidate-shop";

export default function useAddReturnReason(shop: ShopDto) {
	return useApiMutation("post", "/shops/{shopId}/reasons", {
		invalidate: useInvalidateShop(shop.id),
		mapVariables: (variables: CreateShopReturnReasonDto) => ({
			params: { path: { shopId: shop.id } },
			body: variables,
		}),
	});
}
